import React, { useEffect, useState } from "react";
import CommonTopSectionForBorrowers from "../../Components/AllLoans/CommonTopSectionForBorrowers";
import classes from "./LoanDetails.module.css";
import CommonGrid from "../../../../components/CommonGrid";
import { SpinnerBlock } from "../../../../Utils/CustomComponent";
import urls from "../../../../Utils/urls";
import { useSelector } from "react-redux";
import { gridColumns_PastPayments } from "../../../../Utils/TableColumnDefs";
import axios from "../../../../axios";

function ScheduledPayments() {
  const [pastPayments, setPastPayments] = useState();
  const lenderId = useSelector((state) => state.account.lenderId);

  useEffect(() => {
    axios
      .get(urls.dashboard.getPastPayments(lenderId))
      .then((res) => {
        let data = res?.data?.[0] || [];
        setPastPayments(
          data?.map((item, index) => {
            if (item["Account"] !== undefined && item["Account"] !== "") {
              let _item = {};
              let account_id = item["Account"]?.split(">")[1].split("<")[0];
              _item["loan_id"] = item["Account"]
                ?.split("loan/")[1]
                .split("/")[0];
              _item["account"] = account_id;
              _item["address"] = item[""];
              _item["check_date"] = item["Check Date"];
              _item["check_no"] = item["Check Number"];
              _item["amount"] = item["Amount"];
              return _item;
            } else {
              return [];
            }
          })
        );
      })
      .catch((error) => console.error(error));
  }, [lenderId]);
  return (
    <div >
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        {/* Breadscrumb Below */}
        <div className="p-3 pb-0  mt-1">
          <div>
            <ul className={classes.unorderedList}>
              <li>All loans</li>
              <li>
                <span className={classes.spanMargin}>\</span>
              </li>
              <li className={classes.breadcrumbColor}>Scheduled Payments</li>
            </ul>
          </div>
          <div>
            <CommonTopSectionForBorrowers />
          </div>
          <div>
            {pastPayments ? (
              <CommonGrid
                className={"past-payments"}
                title={"Scheduled Payments"}
                gridColumns={gridColumns_PastPayments}
                columnData={JSON.parse(JSON.stringify(pastPayments)).splice(
                  0,
                  pastPayments?.length - 1
                )}
              />
            ) : (
              <SpinnerBlock height="41vh" />
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ScheduledPayments;
